var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { channel: true, selected: _vm.selected },
      on: { click: _vm.selectChannel }
    },
    [
      _c("div", { staticClass: "channel-heading" }, [
        _c(
          "div",
          { staticClass: "channel-status" },
          [
            _vm.connected
              ? _c("check-box", {
                  staticClass: "mr-1 inlined",
                  attrs: {
                    active: { channelSelected: _vm.selected },
                    name: "channelSelected",
                    value: "select"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.channelIcon !== null
              ? _c(
                  "div",
                  { staticClass: "icon inlined" },
                  [
                    _c("q-image", {
                      attrs: {
                        pack: _vm.getIconPack,
                        name: _vm.getIconName,
                        width: "30px",
                        height: "30px"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.connected
              ? _c("div", { staticClass: "inlined not-connected" }, [
                  _c("p", { staticClass: "text" }, [
                    _c("small", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("Campaigns.channel")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(_vm.getUnconnectedLabel)) +
                          "\n          "
                      )
                    ])
                  ])
                ])
              : _c("div", [
                  _vm.connected
                    ? _c("div", [
                        _c(
                          "p",
                          {
                            staticClass:
                              "d-none d-md-block board-label m-0 ml-3 mr-3"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.label) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "d-block d-md-none board-label normal m-0 ml-3 mr-3"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.label) +
                                "\n          "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-channel-actions" },
          [
            !_vm.connected && !_vm.falseUnconnected
              ? _c("input-button", {
                  staticClass: "shorter-input channel-item inlined",
                  attrs: {
                    variant: "standardInput",
                    hollow: "",
                    smaller: "",
                    btnStyle: "ok-style",
                    inputPlaceholder: _vm.$t("Button.connect")
                  },
                  on: { click: _vm.requestConnector }
                })
              : _vm.falseUnconnected
                ? _c(
                    "router-link",
                    { attrs: { to: { name: "userConnections" } } },
                    [
                      _c("input-button", {
                        staticClass: "shorter-input channel-item inlined",
                        attrs: {
                          variant: "standardInput",
                          hollow: "",
                          smaller: "",
                          btnStyle: "ok-style",
                          inputPlaceholder: _vm.$t("Button.edit")
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8873054", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8873054","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/channels/Channel.vue
// module id = null
// module chunks = 